<template>
	<ManagingSection :columnCount="2" header="당첨자 선정" size="s">
		<ManagingBox title="연령대">
			<PeriodBox
				:fromValue="ageMin"
				:toValue="ageMax"
				mode="number"
				fromPrevLabel="최소"
				fromNextLabel="세"
				toPrevLabel="최대"
				toNextLabel="세"
				@change="ageChange"
				@enter="$emit('enter')"
			/>
		</ManagingBox>
		<ManagingBox title="제외 유저">
			<CheckboxList
				v-model="exceptUserType"
				:checkboxList="exceptUserTypeList"
				@enter="$emit('enter')"
			/>
		</ManagingBox>
		<ManagingBox title="피부타입">
			<CheckboxList
				v-model="skinType"
				:checkboxList="skinTypeList"
				@enter="$emit('enter')"
			/>
		</ManagingBox>
		<ManagingBox title="브랜드">
			<CheckboxList
				v-model="exceptBrandCheckedList"
				:checkboxList="exceptBrandCheckList"
				@input="idBrand = null"
				@enter="$emit('enter')"
			/>
			<SearchBrand
				v-if="exceptBrandCheckedList.length > 0"
				ref="SearchBrand"
				@change="idBrand = $event.idBrand"
				@enter="$emit('enter')"
			/>
		</ManagingBox>
		<ManagingBox title="성별">
			<CheckboxList
				v-model="gender"
				:checkboxList="genderList"
				@enter="$emit('enter')"
			/>
		</ManagingBox>
		<ManagingBox title="신청 정보">
			<RadioList
				v-model="searchIncludeFlag"
				valueName="name"
				:radioList="searchIncludeFlagList"
				@enter="$emit('enter')"
			/>
			<input
				v-model="searchKeyWord"
				type="text"
				@keydown.enter="$emit('enter')"
			/>
		</ManagingBox>
		<ManagingBox title="가입일">
			<div class="flex-row">
				<InputText
					mode="number"
					prevLabel="가입 후"
					:propValue="createDateAfterNumber"
					class="filter__join-date__item"
					@input="createDateAfterNumber = emptyStrToNullNum($event)"
					@enter="$emit('enter')"
				/>
				<Selector
					nameKey="value"
					valueKey="id"
					:optionList="createDateTypeCdList"
					v-model="createDateTypeCd"
					class="filter__join-date__item"
					@enter="$emit('enter')"
				/>
				이상
			</div>
			<p class="form-alert">* 가입일과 리뷰작성에서 금일은 0일</p>
		</ManagingBox>
		<ManagingBox title="이미 리뷰 작성한 참여자 제외할 상품번호">
			<input
				v-model="idProducts"
				type="text"
				@keydown.enter="$emit('enter')"
			/>
			<p class="form-alert">콤마로 구분</p>
		</ManagingBox>
		<ManagingBox title="리뷰 작성" :horizontalMode="true">
			<InputText
				mode="number"
				prevLabel="최근"
				:propValue="reviewDateAfterNumber"
				class="filter__review-date__item"
				@input="reviewDateAfterNumber = emptyStrToNullNum($event)"
				@enter="$emit('enter')"
			/>
			<Selector
				nameKey="value"
				valueKey="id"
				:optionList="reviewDateTypeCdList"
				v-model="reviewDateTypeCd"
				class="filter__review-date__item"
				@enter="$emit('enter')"
			/>
			동안 리뷰
			<InputText
				mode="number"
				nextLabel="건 이상 작성"
				:propValue="reviewCount"
				class="filter__review-date__count"
				@input="reviewCount = emptyStrToNullNum($event)"
				@enter="$emit('enter')"
			/>
		</ManagingBox>
		<ManagingBox title="회원 등급">
			<CheckboxList
				v-model="grade"
				:checkboxList="gradeList"
				valueName="name"
				@enter="$emit('enter')"
			/>
		</ManagingBox>
		<ManagingBox title="당첨 여부">
			<RadioList
				v-model="prizeTypeCd"
				:radioList="prizeTypeCdList"
				@enter="$emit('enter')"
			/>
			<div v-if="prizeTypeCd === '02'" class="filter__prize-condition">
				<Selector
					nameKey="value"
					valueKey="id"
					:optionList="eventTypeList"
					v-model="eventType"
					class="filter__prize-condition__selector"
					@enter="$emit('enter')"
				/>
				이벤트 당첨 후
				<InputText
					mode="number"
					nextLabel="일 이상"
					:propValue="eventPrizeAfterDay"
					class="filter__prize-condition__count"
					@input="eventPrizeAfterDay = emptyStrToNullNum($event)"
					@enter="$emit('enter')"
				/>
			</div>
		</ManagingBox>
		<ManagingBox title="픽플 여부">
			<RadioList
				v-model="isPickple"
				:radioList="isPickpleList"
				@enter="$emit('enter')"
			/>
		</ManagingBox>
		<ManagingBox title="휴대폰 번호 인증">
			<RadioList
				v-model="isCertification"
				:radioList="isCertificationList"
				@enter="$emit('enter')"
			/>
		</ManagingBox>
		<ManagingBox title="닉네임">
			<input v-model="nickName" type="text" />
		</ManagingBox>
		<ManagingBox title="인스타그램 카테고리">
			<CheckboxList
				v-model="externalAdvertisingCategoryList"
				:checkboxList="instaCateList"
				valueName="txt"
			/>
		</ManagingBox>
		<ManagingBox
			v-for="item in beautyProfileTypeList"
			:key="item.type"
			:title="item.type"
		>
			<CheckboxList
				v-model="beautyProfileValues"
				:checkboxList="item.list"
			/>
		</ManagingBox>
	</ManagingSection>
</template>
<script>
	import isEqual from 'lodash/isEqual';
	import Util from '@/util';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import PeriodBox from '@/components/PeriodBox.vue';
	import CheckboxList from '@/components/CheckboxList.vue';
	import InputText from '@/components/InputText.vue';
	import Selector from '@/components/Selector.vue';
	import RadioList from '@/components/RadioList.vue';
	import SearchBrand from '@/components/SearchBrand.vue';
	import DateRange from '@/components/DateRange.vue';
	import {
		beautyProfileTypeList,
		exceptUserTypeList,
		skinTypeList,
		exceptBrandCheckList,
		genderList,
		searchIncludeFlagList,
		createDateTypeCdList,
		reviewDateTypeCdList,
		gradeList,
		prizeTypeCdList,
		eventTypeList,
		isPickpleList,
		isCertificationList,
		instaCateList,
	} from '@/constants.js';

	export default {
		name: 'EventWinnerPickSearchFilter',
		components: {
			ManagingSection,
			ManagingBox,
			PeriodBox,
			CheckboxList,
			InputText,
			Selector,
			RadioList,
			SearchBrand,
			DateRange,
		},
		data() {
			return {
				exceptUserTypeList,
				skinTypeList,
				exceptBrandCheckList,
				genderList,
				searchIncludeFlagList,
				createDateTypeCdList,
				reviewDateTypeCdList,
				gradeList,
				prizeTypeCdList,
				eventTypeList,
				isPickple: null,
				isPickpleList,
				isCertificationList,
				instaCateList,
				beautyProfileTypeList,
				keys: [
					'ageMin',
					'ageMax',
					'exceptUserType',
					'skinType',
					'exceptBrandCheckedList',
					'idBrand',
					'gender',
					'searchIncludeFlag',
					'searchKeyWord',
					'createDateAfterNumber',
					'createDateTypeCd',
					'idProducts',
					'reviewDateAfterNumber',
					'reviewDateTypeCd',
					'reviewCount',
					'grade',
					'prizeTypeCd',
					'eventType',
					'eventPrizeAfterDay',
					'isCertification',
					'nickName',
					'externalAdvertisingCategoryList',
					'beautyProfileValues',
					'order',
					'isPickple',
				],
				ageMin: null,
				ageMax: null,
				exceptUserType: exceptUserTypeList.map(item => item.id),
				skinType: skinTypeList.map(item => item.id),
				exceptBrandCheckedList: [],
				idBrand: null,
				gender: genderList.map(item => item.id),
				searchIncludeFlag: searchIncludeFlagList[0].id,
				searchKeyWord: '',
				createDateAfterNumber: null,
				createDateTypeCd: createDateTypeCdList[0].id,
				idProducts: '',
				reviewDateAfterNumber: null,
				reviewDateTypeCd: reviewDateTypeCdList[0].id,
				reviewCount: null,
				grade: gradeList.map(item => item.id),
				prizeTypeCd: prizeTypeCdList[0].id,
				eventType: eventTypeList[0].id,
				eventPrizeAfterDay: null,
				isCertification: isCertificationList[0].id,
				nickName: '',
				externalAdvertisingCategoryList: [],
				beautyProfileValues: [],
			};
		},
		methods: {
			emptyStrToNullNum(str) {
				return Util.emptyStrToNullNum(str);
			},
			ageChange(values) {
				this.ageMin = this.emptyStrToNullNum(values.from);
				this.ageMax = this.emptyStrToNullNum(values.to);
			},
			params() {
				const params = {};
				Object.keys(this).forEach(key => {
					const v = this[key];
					switch (key) {
						case 'ageMin':
						case 'ageMax':
							if (v !== null) params[key] = String(v);
							break;
						case 'exceptUserType':
							if (v.length) {
								v.forEach(typeKey => {
									params[typeKey] = 'true';
								});
							}
							break;
						case 'skinType':
						case 'gender':
						case 'grade':
						case 'externalAdvertisingCategoryList':
							if (v.length) {
								params[key] = v.join(',');
							}
							break;
						case 'beautyProfileValues':
							if (v.length) {
								params.beautyProfileIdList = v.join(',');
							}
							break;
						case 'idBrand':
							if (v && this.exceptBrandCheckedList.length)
								params[key] = String(v);
							break;
						case 'searchKeyWord':
							if (v) {
								params[key] = encodeURIComponent(v);
								params.searchIncludeFlag =
									this.searchIncludeFlag;
							}
							break;
						case 'idProducts':
						case 'isCertification':
							if (v) params[key] = v;
							break;
						case 'nickName':
							if (v) params[key] = encodeURIComponent(v);
							break;
						case 'createDateAfterNumber':
							if (Number.isInteger(v)) {
								params[key] = String(v);
								params.createDateTypeCd = this.createDateTypeCd;
							}
							break;
						case 'reviewDateAfterNumber':
							if (
								Number.isInteger(v) &&
								Number.isInteger(this.reviewCount)
							) {
								params[key] = String(v);
								params.reviewDateTypeCd = this.reviewDateTypeCd;
								params.reviewCount = String(this.reviewCount);
							}
							break;
						case 'prizeTypeCd':
							params[key] = v;
							if (
								v === '02' &&
								Number.isInteger(this.eventPrizeAfterDay)
							) {
								if (this.eventType) {
									params.eventType = String(this.eventType);
								}
								params.eventPrizeAfterDay = String(
									this.eventPrizeAfterDay
								);
							}
							break;
						case 'isPickple':
							if (v !== null) params[key] = v;
							break;
					}
				});
				return params;
			},
			setFilter(query) {
				Object.keys(query).forEach(idx => {
					const key = this.keys[idx];
					const v = query[idx];
					if (this.keys.hasOwnProperty(idx)) {
						switch (key) {
							case 'ageMin':
							case 'ageMax':
							case 'createDateAfterNumber':
							case 'reviewDateAfterNumber':
							case 'reviewCount':
							case 'eventPrizeAfterDay':
								const parsedV = parseInt(v);
								if (!isNaN(parsedV)) {
									this[key] = parsedV;
								}
								break;
							case 'exceptUserType':
							case 'skinType':
							case 'exceptBrandCheckedList':
							case 'gender':
							case 'grade':
							case 'externalAdvertisingCategoryList':
							case 'beautyProfileValues':
								this[key] = v.split(',');
								break;
							case 'idBrand':
								this[key] = Number(v);
								this.$nextTick(() => {
									this.$refs.SearchBrand.setBrandOnlyId(
										Number(v)
									);
								});
								break;
							case 'searchIncludeFlag':
							case 'searchKeyWord':
							case 'createDateTypeCd':
							case 'idProducts':
							case 'reviewDateTypeCd':
							case 'prizeTypeCd':
							case 'eventType':
							case 'isCertification':
							case 'nickName':
								this[key] = v;
								break;
							case 'isPickple':
								this[key] =
									v === 'true' || v === true
										? true
										: v === 'false' || v === false
											? false
											: null;
								break;
						}
					}
				});
			},
			isDefaultValue(key) {
				const v = this[key];
				switch (key) {
					case 'ageMin':
					case 'ageMax':
					case 'idBrand':
					case 'createDateAfterNumber':
					case 'reviewDateAfterNumber':
					case 'reviewCount':
					case 'eventPrizeAfterDay':
						return v === null;
					case 'exceptUserType':
					case 'skinType':
					case 'gender':
					case 'grade':
						return isEqual(
							v.sort(),
							this[`${key}List`].map(item => item.id).sort()
						);
					case 'exceptBrandCheckedList':
					case 'externalAdvertisingCategoryList':
					case 'beautyProfileValues':
						return v.length === 0;
					case 'searchIncludeFlag':
					case 'createDateTypeCd':
					case 'reviewDateTypeCd':
					case 'prizeTypeCd':
					case 'eventType':
					case 'isCertification':
						return v === this[`${key}List`][0].id;
					case 'searchKeyWord':
					case 'idProducts':
					case 'nickName':
						return v === '';
					case 'isPickple':
						return v === null;
				}
			},
			setQueryStr(order) {
				const query = this.keys.reduce((acc, key, idx) => {
					const v = this[key];
					if (!this.isDefaultValue(key))
						acc[idx] = Array.isArray(v) ? v.join(',') : v;
					if (key === 'order') acc[idx] = order;
					return acc;
				}, {});
				this.$router.replace({ query }).catch(() => {});
			},
			init() {
				Object.keys(this).forEach(key => {
					switch (key) {
						case 'ageMin':
						case 'ageMax':
						case 'idBrand':
						case 'createDateAfterNumber':
						case 'reviewDateAfterNumber':
						case 'reviewCount':
						case 'eventPrizeAfterDay':
							this[key] = null;
							break;
						case 'exceptUserType':
						case 'skinType':
						case 'gender':
						case 'grade':
							this[key] = this[`${key}List`].map(item => item.id);
							break;
						case 'exceptBrandCheckedList':
						case 'externalAdvertisingCategoryList':
						case 'beautyProfileValues':
							this[key] = [];
							break;
						case 'searchIncludeFlag':
						case 'createDateTypeCd':
						case 'reviewDateTypeCd':
						case 'prizeTypeCd':
						case 'eventType':
						case 'isCertification':
							this[key] = this[`${key}List`][0].id;
							break;
						case 'searchKeyWord':
						case 'idProducts':
						case 'nickName':
							this[key] = '';
							break;
					}
				});
			},
		},
	};
</script>
<style lang="scss" scoped>
	.filter__join-date__item,
	.filter__review-date__item,
	.filter__prize-condition__selector {
		margin-right: 8px;
	}

	.filter__review-date__count,
	.filter__prize-condition__count {
		margin-left: 20px;
	}

	.filter__prize-condition {
		display: flex;
		align-items: center;
	}
</style>
